import React from 'react'
import { Button } from './'

const ConfigureAppButton = ({ label, appId, onClick, type }) => (
	<Button
		type={type ? type : 'lc2-install'}
		onClick={onClick}
		icon={'settings'}
	>
		{label ? label : 'Configure app'}
	</Button>
)

export default ConfigureAppButton



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Button/ConfigureAppButton.js